import { useState } from "react";

import { HeaderLanding } from "../components/ui/header-landings";
import { Footer } from "../components/ui/footer";

export default function PrivacyPolicyPage() {
  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <HeaderLanding />

      <main>
        {/* Hero Section */}
        <section className="border-b-2 border-black py-16 bg-[#F3F4F6]">
          <div className="px-4 sm:px-8 max-w-7xl mx-auto text-center">
            <h1 className="text-4xl sm:text-5xl font-black tracking-tighter mb-4">
              AVISOS DE PRIVACIDAD
            </h1>
          </div>
        </section>

        {/* FAQ Section */}
        <section className="py-16 border-b-2 border-black">
          <div className="px-4 sm:px-8 max-w-4xl mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-3xl sm:text-4xl font-bold tracking-tight">
                INFORMACIÓN GENERAL
              </h2>
              <p className="text-[#4B5563] mt-4 text-justify">
                Zeitex Sorteos se compromete a cumplir con las bases de los
                sorteos y a hacer cumplir las reglas de los mismos.
              </p>
              <p className="text-[#4B5563] mt-4 text-justify">
                La información e imágenes publicadas en este sitio han sido
                proporcionadas por Zeitex Sorteos; quien es responsable del
                sitio web , del contenido publicado, de los sorteos y del
                tratamiento de la información proporcionada o recabada en el
                mismo.
              </p>
              <p className="text-[#4B5563] mt-4 text-justify">
                Por otra parte, Lotto Digital únicamente actúa como prestador de
                servicios de diseño web, desarrollo web, mantenimiento del sitio
                y subarrendador de Hosting y Dominio.
              </p>
              <h2 className="text-3xl mt-4 sm:text-3xl font-bold tracking-tight">
                AVISO DE PRIVACIDAD PARA PROSPECTOS
              </h2>
              <p className="text-[#4B5563] mt-4 text-justify">
                DATOS PERSONALES RECABADOS POR ZEITEX SORTEOS
              </p>
              <p className="text-[#4B5563] mt-4 text-justify">
                Para efectos de cumplir con las finalidades previstas en este
                Aviso de Privacidad, recabaremos de usted los siguientes datos
                personales:
              </p>
              <p className="text-[#4B5563] mt-4 text-justify">
                Datos de identificación
              </p>
              <p className="text-[#4B5563] text-justify">Datos de contacto</p>
              <p className="text-[#4B5563] mt-4 text-justify">
                Le informamos que los datos personales anteriores los podemos
                obtener cuando usted nos los proporciona de forma directa o bien
                de forma indirecta a través de fuentes de acceso público.
              </p>
              <p className="text-[#4B5563] mt-4 text-justify">
                USO DE DATOS PERSONALES
              </p>
              <p className="text-[#4B5563] mt-4 text-justify">
                Finalidades primarias:
              </p>
              <p className="text-[#4B5563] mt-4 text-justify">
                Los datos personales que usted nos proporcione podrán ser
                utilizados para las siguientes finalidades:
              </p>
              <p className="text-[#4B5563] mt-4 text-justify">
                1. Para identificarle y registrarle como un posible prospecto de
                venta.
              </p>
              <p className="text-[#4B5563] mt-4 text-justify">
                2. Para determinar si usted es apto para adquirir nuestros
                productos o servicios.
              </p>
              <p className="text-[#4B5563] mt-4 text-justify">
                3. Para contactarle, a través de diversos medios de comunicación
                físicos y electrónicos con el propósito de ofrecerle nuestros
                productos y servicios.
              </p>
              <p className="text-[#4B5563] mt-4 text-justify">
                4. Para dar seguimiento a sus solicitudes de información sobre
                nuestros productos y servicios o cualquier otra cuestión que
                resulte de nuestra competencia.
              </p>
              <p className="text-[#4B5563] mt-4 text-justify">
                5. Para cumplir con obligaciones previstas en la normatividad
                aplicable así como cooperar con autoridades competentes en caso
                de que así se requiera.
              </p>
              <p className="text-[#4B5563] mt-4 text-justify">
                Finalidades secundarias:
              </p>
              <p className="text-[#4B5563] mt-4 text-justify">
                De manera adicional, si usted no se opone, Lotto Sorteos
                mantendrá su información personal para las siguientes
                finalidades:
              </p>
              <p className="text-[#4B5563] mt-4 text-justify">
                1. Para posibles contactos posteriores.
              </p>
              <p className="text-[#4B5563] mt-2 text-justify">
                2. Para enviarle información promocional sobre nuestros avances,
                eventos, promociones y servicios de Lotto Sorteos así como, para
                mantener contacto con usted como posible participante.
              </p>
              <p className="text-[#4B5563] mt-2 text-justify">
                3.Para realizar investigaciones de mercado y promoción de
                productos.
              </p>
              <p className="text-[#4B5563] mt-2 text-justify">
                4. Para fines estadísticos.
              </p>
              <p className="text-[#4B5563] mt-4 text-justify">
                MECANISMOS PARA EXPRESAR NEGATIVA AL TRATAMIENTO DE SUS DATOS
                PERSONALES
              </p>
              <p className="text-[#4B5563] mt-4 text-justify">
                En caso de que no desee que sus datos personales sean tratados
                para alguna o todas las finalidades secundarias, desde este
                momento nos puede comunicar lo anterior al whatsapp: (55) 64 72
                32 23.
              </p>
              <p className="text-[#4B5563] mt-4 text-justify">
                CON QUIÉN PODEMOS COMPARTIR SUS DATOS PERSONALES
              </p>
              <p className="text-[#4B5563] mt-4 text-justify">
                Para cumplir con las finalidades exigidas legalmente o por
                autoridades competentes, Lotto Sorteos sólo transferirá los
                datos necesarios en los casos legalmente previstos.
              </p>
              <p className="text-[#4B5563] mt-4 text-justify">
                Tercero receptor de los datos personales: Autoridades
                competentes
              </p>
              <p className="text-[#4B5563] text-justify">
                Finalidad: En los casos legalmente previstos
              </p>
              <p className="text-[#4B5563] text-justify">
                Consentimiento: No necesario
              </p>
              <p className="text-[#4B5563] my-4 text-justify">
                MEDIOS PARA EJERCER LOS DERECHOS ARCO Y/O REVOCACIÓN DEL
                CONSENTIMIENTO
              </p>
              <p className="text-[#4B5563] my-4 text-justify">
                Usted por sí o mediante representante legal debidamente
                acreditado, podrá ejercer sus derechos de acceso, rectificación,
                cancelación y oposición (ARCO), así como revocar su
                consentimiento para el tratamiento de sus datos personales
                enviando un whatsapp a (55) 64 72 32 23. En este sentido, puede
                informarse sobre los procedimientos, requisitos y plazos para el
                ejercicio de sus Derechos ARCO y/o revocación del consentimiento
                en nuestra página de internet:
                https://sorteos.zeitex.com.mx/privacy-policy
              </p>
              <p className="text-[#4B5563] my-4 text-justify">
                LIMITACIÓN DE USO Y/O DIVULGACIÓN DE SUS DATOS PERSONALES
              </p>
              <p className="text-[#4B5563] my-4 text-justify">
                Usted podrá limitar el uso o divulgación de sus datos personales
                enviando su solicitud a Lotto Sorteos al whatsapp (55) 64 72 32
                23. En caso de que su solicitud sea procedente se le registrará
                en el listado de exclusión propio de Zeitex Sorteos.
              </p>
              <p className="text-[#4B5563] my-4 text-justify">
                ACTUALIZACIONES Y/O MODIFICACIONES AL AVISO DE PRIVACIDAD.
              </p>
              <p className="text-[#4B5563] my-4 text-justify">
                Zeitex Sorteos le notificará de cualquier cambio a su aviso de
                privacidad a través de la página:
                https://sorteos.zeitex.com.mx/privacy-policy
              </p>
              <p className="text-[#4B5563] my-4 text-justify">COOKIES</p>
              <p className="text-[#4B5563] my-4 text-justify">
                Zeitex Sorteos utiliza varias tecnologías para mejorar la
                eficiencia de sus sitios web, incluyendo su experiencia cuando
                navega por dichos sitios. Entre estas tecnologías se incluye el
                uso de cookies. Las cookies son pequeñas cantidades de
                información que se almacenan en el navegador utilizado por cada
                usuario para que el servidor recuerde cierta información que
                posteriormente pueda utilizar. Esta información permite
                identificarle y guardar sus preferencias personales para
                brindarle una mejor experiencia de navegación. Le recordamos que
                usted puede deshabilitar o ajustar el uso de cookies siguiendo
                los procedimientos del navegador de internet que utiliza.
              </p>
              <p className="text-[#4B5563] my-4 text-justify">AUTORIDAD</p>
              <p className="text-[#4B5563] my-4 text-justify">
                En caso de considerarlo necesario, le informamos que tiene el
                derecho de acudir ante el Instituto Nacional de Transparencia
                Acceso a la Información y Protección de Datos Personales (INAI)
                para hacer efectivos sus derechos.
              </p>
              <p className="text-[#4B5563] my-4 text-justify">
                ACEPTACIÓN DEL AVISO DE PRIVACIDAD
              </p>
              <p className="text-[#4B5563] my-4 text-justify">
                Al proporcionarnos sus datos para las finalidades señaladas
                usted, usted reconoce haber leído nuestro Aviso de Privacidad y
                acepta el tratamiento de su información personal de acuerdo al
                contenido en el mismo.
              </p>
              <p className="text-[#4B5563] my-4 text-justify">
                Fecha de última actualización: 03 de Mayo de 2026.
              </p>
              <h2 className="text-3xl mt-4 sm:text-3xl font-bold tracking-tight">
                AVISO DE PRIVACIDAD PARA PARTICIPANTES
              </h2>
              <p className="text-[#4B5563] my-4 text-justify">
                SUS DATOS PERSONALES Y DATOS PERSONALES SENSIBLES
              </p>
              <p className="text-[#4B5563] my-4 text-justify">
                Los datos personales que Zeitex Sorteos obtiene por parte de sus
                usuarios, clientes, proveedores y/o cualquier persona
                relacionada con sus actividades, se encuentran mencionados en la
                siguiente clasificación:
              </p>
              <p className="text-[#4B5563] my-4 text-justify">
                Datos de Identificación.
              </p>
              <p className="text-[#4B5563] text-justify">Datos de Contacto.</p>
              <p className="text-[#4B5563] text-justify">
                Datos de tarjetas de crédito.
              </p>
              <p className="text-[#4B5563] mt-4 text-justify">
                Le informamos que el tratamiento de dichos datos es necesario
                para cumplir las obligaciones derivadas de la relación jurídica
                entre usted y Lotto Sorteos, razón por la cual su consentimiento
                se encuentra exceptuado.
              </p>
              <p className="text-[#4B5563] mt-4 text-justify">
                USO DE SUS DATOS PERSONALES.
              </p>
              <p className="text-[#4B5563] mt-4 text-justify">
                Finalidades primarias:
              </p>
              <p className="text-[#4B5563] mt-4 text-justify">
                1. Identificación
              </p>
              <p className="text-[#4B5563] mt-1 text-justify">
                2. Contacto para temas relacionados con el pago del boleto que
                adquirió, la premiación, en su caso, del boleto que adquirió.
              </p>
              <p className="text-[#4B5563] mt-1 text-justify">
                3. Informar acerca del desarrollo y resultados de los distintos
                sorteos.
              </p>
              <p className="text-[#4B5563] mt-1 text-justify">
                4. Realizar publicaciones dentro de nuestras listas de
                ganadores, en caso de resultar agraciado el boleto que adquirió.
              </p>
              <p className="text-[#4B5563] mt-4 text-justify">
                Le informamos que usted no puede solicitar que Zeitex Sorteos
                cese el tratamiento de sus datos para las finalidades primarias
                y necesarias, anteriormente mencionadas, en virtud de que el
                tratamiento es necesario para cumplir obligaciones derivadas de
                la relación entre usted y Zeitex Sorteos.
              </p>
              <p className="text-[#4B5563] mt-4 text-justify">
                Finalidades secundarias:
              </p>
              <p className="text-[#4B5563] mt-4 text-justify">
                Una vez que se haya cumplido con el desarrollo del sorteo en que
                usted participe, Lotto Sorteos conservará su información
                personal:
              </p>
              <p className="text-[#4B5563] mt-4 text-justify">
                1. Para informarle sobre nuestros avances, eventos, promociones
                y servicios de Sorteos Sonora así como, para mantener contacto
                con usted como participante.
              </p>
              <p className="text-[#4B5563] mt-1 text-justify">
                2. Solicitar información para realizar investigaciones de
                mercado y promoción de productos.
              </p>
              <p className="text-[#4B5563] mt-1 text-justify">
                3. Hacer consultas, investigaciones y revisiones en relación a
                sus quejas o reclamaciones.
              </p>
              <p className="text-[#4B5563] mt-1 text-justify">
                4. Para fines estadísticos.
              </p>
              <p className="text-[#4B5563] mt-4 text-justify">
                MECANISMOS PARA EXPRESAR NEGATIVA AL TRATAMIENTO DE SUS DATOS
                PERSONALES
              </p>
              <p className="text-[#4B5563] mt-4 text-justify">
                En caso de que no desee que sus datos personales sean tratados
                para alguna o todas las finalidades secundarias, desde este
                momento nos puede comunicar lo anterior al whatsapp: (55) 64 72
                32 23
              </p>
              <p className="text-[#4B5563] mt-4 text-justify">
                La negativa para el uso de sus datos personales para fines
                adicionales o secundarios, no podrá ser un motivo para negarle
                los servicios establecidos o dar por terminada la relación
                establecida con nosotros.
              </p>
              <p className="text-[#4B5563] mt-4 text-justify">
                CON QUIÉN PODEMOS COMPARTIR SUS DATOS PERSONALES.
              </p>
              <p className="text-[#4B5563] mt-4 text-justify">
                Zeitex Sorteos para cumplir las finalidades exigidas legalmente
                o por las autoridades competentes sólo transferirá los datos
                necesarios en los casos legalmente previstos.
              </p>
              <p className="text-[#4B5563] mt-4 text-justify">
                Tercero receptor de los datos personales: Instituciones
                bancarias, Autoridades competentes
              </p>
              <p className="text-[#4B5563] text-justify">
                Finalidad: Para realizar las gestiones de pagos necesarias, En
                los casos legalmente previstos
              </p>
              <p className="text-[#4B5563] text-justify">
                Consentimiento: No necesario
              </p>
              <p className="text-[#4B5563] mt-4 text-justify">
                MEDIOS PARA EJERCER LOS DERECHOS ARCO Y/O REVOCACIÓN DEL
                CONSENTIMIENTO
              </p>
              <p className="text-[#4B5563] mt-4 text-justify">
                Usted por sí o mediante representante legal debidamente
                acreditado, podrá ejercer sus derechos de acceso, rectificación,
                cancelación y oposición (ARCO), así como revocar su
                consentimiento para el tratamiento de sus datos personales
                enviando un whatsapp a (55) 64 72 32 23.
              </p>
              <p className="text-[#4B5563] mt-4 text-justify">
                En este sentido, puede informarse sobre los procedimientos,
                requisitos y plazos para el ejercicio de sus Derechos ARCO y/o
                revocación del consentimiento en nuestra página de internet:
                https://sorteos.zeitex.com.mx/privacy-policy
              </p>
              <p className="text-[#4B5563] mt-4 text-justify">
                CÓMO PROTEGEMOS Y EVITAMOS LA DIVULGACIÓN DE SUS DATOS
                PERSONALES.
              </p>
              <p className="text-[#4B5563] mt-4 text-justify">
                Usted podrá limitar el uso o divulgación de sus datos personales
                enviando su solicitud a Lotto Sorteos al whatsapp (55) 64 72 32
                23. En caso de que su solicitud sea procedente se le registrará
                en el listado de exclusión propio de Zeitex Sorteos.
              </p>
              <p className="text-[#4B5563] mt-4 text-justify">
                ACTUALIZACIONES Y/O MODIFICACIONES AL AVISO DE PRIVACIDAD.
              </p>
              <p className="text-[#4B5563] mt-4 text-justify">
                Zeitex Sorteos le notificará de cualquier cambio a su aviso de
                privacidad a través de la página:
                https://sorteos.zeitex.com.mx/privacy-policy
              </p>
              <p className="text-[#4B5563] mt-4 text-justify">COOKIES</p>
              <p className="text-[#4B5563] mt-4 text-justify">
                Zeitex Sorteos utiliza varias tecnologías para mejorar la
                eficiencia de sus sitios web, incluyendo su experiencia cuando
                navega por dichos sitios. Entre estas tecnologías se incluye el
                uso de cookies. Las cookies son pequeñas cantidades de
                información que se almacenan en el navegador utilizado por cada
                usuario para que el servidor recuerde cierta información que
                posteriormente pueda utilizar. Esta información permite
                identificarle y guardar sus preferencias personales para
                brindarle una mejor experiencia de navegación. Le recordamos que
                usted puede deshabilitar o ajustar el uso de cookies siguiendo
                los procedimientos del navegador de internet que utiliza.
              </p>
              <p className="text-[#4B5563] mt-4 text-justify">AUTORIDAD</p>
              <p className="text-[#4B5563] mt-4 text-justify">
                En caso de considerarlo necesario, le informamos que tiene el
                derecho de acudir ante el Instituto Nacional de Transparencia
                Acceso a la Información y Protección de Datos Personales (INAI)
                para hacer efectivos sus derechos.
              </p>
              <p className="text-[#4B5563] mt-4 text-justify">
                ACEPTACIÓN DEL AVISO DE PRIVACIDAD
              </p>
              <p className="text-[#4B5563] mt-4 text-justify">
                Al utilizar nuestros productos y/o servicios, usted acepta el
                tratamiento de su información personal de acuerdo al contenido
                de nuestro aviso de privacidad.
              </p>
              <p className="text-[#4B5563] mt-4 text-justify">
                Fecha de última actualización: 03 de Mayo de 2026.
              </p>
            </div>
          </div>
        </section>
      </main>

      {/* Footer */}
      <Footer />
    </div>
  );
}
